/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React, { Component } from "react";
import {BrowserRouter as Router, Route} from "react-router-dom";
import Routes from "./routes";
import { AuthProvider, AuthConsumer } from "./components/context/AuthContext";
import SideNavBar from "./components/widgets/SideNavBar/SideNavBar";
import LoadingIndicator from "./components/widgets/LoadingIndicator/LoadingIndicator";
import HomePage from "./components/pages/HomePage/HomePage";
import { PERMISSIONS } from "./constants/APP_CONSTANTS";

const basename = '/admintool';

class App extends Component {
    state = {
        isSidebarExpanded: false
    }

    toggleSidebar = () => {
        this.setState(prevState => ({
            isSidebarExpanded: !prevState.isSidebarExpanded
        }));
    }

    render() {
        return (
            <AuthProvider>
                <Router basename={basename}>
                    <AuthConsumer>
                        {({isLoggedIn,userProfile}) =>
                            <div className="pe-container root-container">
                                { isLoggedIn ?
                                    !(userProfile.permissions.includes(PERMISSIONS.hide_only_sidebar)) ? (
                                        !(userProfile.permissions.includes(PERMISSIONS.view_only_sidebar_expanded)) ? (<div className={`page ${(this.state.isSidebarExpanded ? "sidebar-expanded" : "")}`}>
                                            <SideNavBar isExpanded={this.state.isSidebarExpanded} toggleExpanded={this.toggleSidebar} permissions = {userProfile.permissions}/>
                                            <Routes/>
                                        </div>
                                        ) : (<div className={`page ${(this.state.isSidebarExpanded ? "" : "sidebar-expanded")}`}>
                                            <SideNavBar isExpanded={this.state.isSidebarExpanded} toggleExpanded={this.toggleSidebar} permissions = {userProfile.permissions}/>
                                            <Routes/>
                                        </div>
                                        )
                                    ) : <Route path="/" exact component={HomePage}/>
                                    : <LoadingIndicator />}
                            </div>
                        }
                    </AuthConsumer>
                </Router>
            </AuthProvider>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js